import myAxios from "@/utils/request";
export default {
  // 根据用户获取导航菜单
  getMenu() {
    return myAxios.get("/api/user/getmenubytoken");
  },
  // 获取用户列表
  getList(params) {
    return myAxios.post("/api/user/backcerselect", params);
  },
  // 删除用户
  batchDelete(params) {
    return myAxios.post("/api/user/deletecomuser", params);
  },
  // 修改用户状态
  changeUserStatus(params) {
    return myAxios.post("/api/user/bacuserstatus", params);
  },
  // 添加新用户
  createUser(params) {
    return myAxios.post("/api/user/addfrontuser", params);
  },

  // 获取个人认证详细信息
  getPerCerInfo(params) {
    const { id } = params;
    return myAxios.get("/api/user/percertificateinfo?id=" + id);
  },
  // 修改个人认证信息 废弃无用
  modifyPerCerUser(params) {
    return myAxios.post("/api/user/backupdatepersonal", params);
  },
  // 审核个人认证信息 废弃无用
  aduitPerCerUser(params) {
    return myAxios.post("/api/user/backapproveper", params);
  },
  // 获取企业认证详细信息
  getComCerInfo(params) {
    const { id } = params;
    return myAxios.get("/api/user/comcertificateinfo?id=" + id);
  },
  // 修改企业认证信息 废弃无用
  modifyComCerUser(params) {
    return myAxios.post("/api/user/backupdatecom", params);
  },
  // 审核企业认证信息
  aduitComCerUser(params) {
    return myAxios.post("/api/user/backapprovecom", params);
  },
  getUserIssueachievement(params) {
    return myAxios.post("/api/achievement/usertopachipaging", params);
  },
  getUserIssuedemand(params) {
    return myAxios.post("/api/requirement/usertopreqpaging", params);
  },
  getUserIssuepatent(params) {
    return myAxios.post("/api/patent/usertoppatentpaging", params);
  },
  getUserDocking(params) {
    return myAxios.post("/api/project/getprojectlistbyuserid", params);
  },
  // 获取已认证用户列表
  getCertifiedList(params) {
    return myAxios.post("/api/user/bacuserselect", params);
  },

  // 获取消息发送的用户列表
  getNotificationUserList(params) {
    return myAxios.post("/api/user/getuserbyselect", params);
  }
};
